import React, { Component } from 'react';
import { HiOutlineEnvelope } from 'react-icons/hi2';
import axios from 'axios';

class CTAForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: '',
        };
    }
    handleChange = (e) => {
        this.setState({ email: e.target.value });
    };
    handleSubmit = async () => {
        const emailRegex = new RegExp(
            // eslint-disable-next-line
            /^[A-Za-z0-9_!#$%&'*+\/=?`{|}~^.-]+@[A-Za-z0-9.-]+$/,
            'gm'
        );
        const isValidEmail = emailRegex.test(this.state.email);
        if (this.state.email !== '') {
            if (isValidEmail) {
                const saveform = await axios.post(
                    'https://enr95mz778.execute-api.eu-west-1.amazonaws.com/Prod/newsletter-cloudplexo',
                    { email: this.state.email }
                );
                if (saveform.status === 200) {
                    alert('Email address submitted successfully');
                    this.setState({ email: '' });
                } else {
                    alert('Form not submitted');
                }
            } else {
                alert('Invalid format');
            }
        } else {
            alert('Empty input! Fill in your email address');
        }
    };

    render() {
        return (
            <div className="hero-cta">
                <HiOutlineEnvelope size={30} />

                <input
                    type="text"
                    placeholder="Enter your work email address"
                    value={this.state.email}
                    onChange={this.handleChange}
                />
                {/* eslint-disable-next-line */}
                <a
                    className="btn btn-mobile-i"
                    onClick={this.handleSubmit}
                >
                    Subscribe
                </a>
            </div>
        );
    }
}

export default CTAForm;
